import React, { useState, useEffect } from 'react';
import ChatBot from './ChatBot';

/**
 * ChatBotTrigger Component
 * Floating button that toggles the chatbot open/closed
 */
const ChatBotTrigger = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [iconLoadFailed, setIconLoadFailed] = useState(false);
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [showBubble, setShowBubble] = useState(true);
  const [visible, setVisible] = useState(true);
  const chatbotIconSrc = '/chatbot-agent.png';

  const messages = [
    "I'm here if you need help.",
    "My name is Hy-Bot your trusted chatbot."
  ];

  useEffect(() => {
    // Hide bubble automatically after 3 minutes
    const hideTimer = setTimeout(() => {
      setShowBubble(false);
    }, 180000);

    const messageInterval = setInterval(() => {
      // Fade out
      setVisible(false);
      setTimeout(() => {
        setCurrentMessageIndex((prev) => (prev + 1) % messages.length);
        // Fade in next message
        setVisible(true);
      }, 500);
    }, 3000);

    return () => {
      clearTimeout(hideTimer);
      clearInterval(messageInterval);
    };
  }, [messages.length]);

  return (
    <>
      {isOpen ? (
        <ChatBot isOpen={isOpen} onClose={() => setIsOpen(false)} />
      ) : (
        <div className="fixed bottom-9 -right-4 z-40 flex items-center gap-1">
          
          {/* Message Bubble */}
          {showBubble && (
            <div
              className="relative bg-[#F8EBDD] text-[#2D2D2D] rounded-2xl px-4 py-2 shadow-lg whitespace-nowrap text-sm font-medium flex items-center gap-1 translate-x-7"
              style={{
                opacity: visible ? 1 : 0,
                transition: 'opacity 2s ease-in-out',
              }}
            >
              <span>{messages[currentMessageIndex]}</span>
              
              {/* Close "X" Button */}
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  setShowBubble(false);
                }}
                className="ml-1 rounded-full p-0.5 hover:bg-black/10 transition-colors flex items-center justify-center"
                aria-label="Close message"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>

              {/* Small tail pointing to the icon */}
              <div className="absolute right-[-6px] top-1/2 -translate-y-1/2 w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-l-[8px] border-l-[#F8EBDD]"></div>
            </div>
          )}

          {/* Chat Icon Button */}
          <button
            onClick={() => setIsOpen(true)}
            className="group flex h-32 w-32 flex-shrink-0 items-center justify-center rounded-full bg-transparent transition-transform duration-15 hover:-translate-y-1 hover:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#F8EBDD]"
            style={{
              filter: 'drop-shadow(0 8px 14px rgba(58, 37, 18, 0.35)) drop-shadow(0 0 10px rgba(221, 177, 120, 0.35))',
            }}
            title="Open Hygea Support Chat"
            aria-label="Open Hygea Support Chat"
          >
            {!iconLoadFailed ? (
              <img
                src={chatbotIconSrc}
                alt="Chat support"
                className="relative z-10 h-full w-full object-contain"
                loading="lazy"
                onError={() => setIconLoadFailed(true)}
              />
            ) : (
              <svg
                className="relative z-10 h-[90%] w-[90%] drop-shadow-[0_2px_3px_rgba(58,37,18,0.35)]"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 3C6.48 3 2 6.94 2 11.8c0 2.54 1.25 4.82 3.25 6.42L4.3 21a.75.75 0 0 0 .95.92l3.25-1.22c1.1.31 2.28.48 3.5.48 5.52 0 10-3.94 10-8.8S17.52 3 12 3Z" />
                <circle cx="8.75" cy="11.95" r="1" fill="#F7ECDF" />
                <circle cx="12" cy="11.95" r="1" fill="#F7ECDF" />
                <circle cx="15.25" cy="11.95" r="1" fill="#F7ECDF" />
              </svg>
            )}
          </button>
        </div>
      )}

      <style>{`
        @keyframes fade {
          0% { opacity: 0; transform: translateX(10px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        .animate-fade {
          animation: fade 1s ease-out;
        }
      `}</style>
    </>
  );
};

export default ChatBotTrigger;